import type { ReactNode } from 'react'
import { textColor } from '../typography'

/**
 * Renders a field label, colouring a trailing required marker in the Figma's
 * #E0645B rather than the label grey (node 4352:18988). Callers keep passing a
 * plain string, so nothing else has to change.
 */
export function labelContent(label: string): ReactNode {
  const marker = /\s\*$/.exec(label)
  if (!marker) return label
  return (
    <>
      {label.slice(0, marker.index)}
      <span style={{ color: textColor.required }} aria-hidden> *</span>
      <span className="sr-only"> (required)</span>
    </>
  )
}
